import de from '@translations/de/uploadJSONInput.json';
import en from '@translations/en/uploadJSONInput.json';
import pl from '@translations/pl/uploadJSONInput.json';
import sl from '@translations/sl/uploadJSONInput.json';
import uk from '@translations/uk/uploadJSONInput.json';
import bg from '@translations/bg/uploadJSONInput.json';
import cz from '@translations/cz/uploadJSONInput.json';
import fr from '@translations/fr/uploadJSONInput.json';
import gr from '@translations/gr/uploadJSONInput.json';
import it from '@translations/it/uploadJSONInput.json';
import pr from '@translations/pr/uploadJSONInput.json';
import ru from '@translations/ru/uploadJSONInput.json';
import sk from '@translations/sk/uploadJSONInput.json';
import sp from '@translations/sp/uploadJSONInput.json';
import tr from '@translations/tr/uploadJSONInput.json';
import hu from '@translations/hu/uploadJSONInput.json';
import { ITranslations } from '@/types/common';
import { UploadJSONInputTransFields } from './types';

export const uploadJSONInputTranslations: ITranslations<UploadJSONInputTransFields> = {
  name: 'uploadJSONInput',
  de,
  en,
  pl,
  sl,
  uk,
  bg,
  cz,
  fr,
  gr,
  it,
  pr,
  ru,
  sk,
  sp,
  tr,
  hu,
};
